import {
  GET_HAS_DOMICILIATION,
  GET_HAS_DOMICILIATION_SUCCESS,
  GET_HAS_DOMICILIATION_ERROR,
  GET_MESSAGES_DOMICILIATION,
  DOMICILIATION_REFERENCE,
  DOMICILIATION_REFERENCE_SUCCESS,
  DOMICILIATION_REFERENCE_ERROR,
  SET_DOMICILIATION_REFERENCE_VALUES,
  CAN_CALL_NIP,
  CAN_UPSELL_N2,
  SET_GO_TO_DOMICILIATION_FORM,
  SET_DATE_FROM_NATIVE_DATE_PICKER,
  SET_FROM_ACTION_VALUE,
  SET_TERMS_CHECKBOX,
  SET_MAX_AMOUNT_VALUE
} from "../actions/domiciliation";

const initialState = {
  isLoadingServiceDomiciliation: false,
  hasDomiciliationServiceResponseSuccess: {},
  hasDomiciliationServiceResponseError: undefined,
  messagesDomiciliation: [],
  domiciliationReferenceResponse: {},
  domiciliationReferenceResponseError: undefined,
  reference: "",
  expirationDate: "",
  amountValue: 0,
  tcValue: false,
  canCallNip: false,
  canUpsellN2: false,
  tcInputIsValid: false,
  dataValueFromNativeDatePicker: {}
};

export default (
  state = initialState,
  {
    type,
    hasDomiciliationServiceResponseSuccess,
    hasDomiciliationServiceResponseError,
    messagesDomiciliation,
    domiciliationReferenceResponse,
    domiciliationReferenceResponseError,
    reference,
    expirationDate,
    amountValue,
    tcValue,
    canCallNip,
    canUpsellN2,
    tcInputIsValid,
    payload,
  }
) => {
  switch (type) {
    case GET_HAS_DOMICILIATION:
      return {
        ...state,
        isLoadingServiceDomiciliation: true,
      };
    case GET_HAS_DOMICILIATION_SUCCESS:
      return {
        ...state,
        hasDomiciliationServiceResponseSuccess,
        isLoadingServiceDomiciliation: false,
        hasDomiciliationServiceResponseError: undefined,
      };
    case GET_HAS_DOMICILIATION_ERROR:
      return {
        ...state,
        hasDomiciliationServiceResponseError,
        isLoadingServiceDomiciliation: false,
        hasDomiciliationServiceResponseSuccess: {},
      };
    case GET_MESSAGES_DOMICILIATION:
      return {
        ...state,
        messagesDomiciliation,
      };

    case DOMICILIATION_REFERENCE:
      return {
        ...state,
        isLoadingServiceDomiciliation: true,
      };
    case DOMICILIATION_REFERENCE_SUCCESS:
      return {
        ...state,
        domiciliationReferenceResponse,
        isLoadingServiceDomiciliation: false,
        domiciliationReferenceResponseError: undefined,
      };
    case DOMICILIATION_REFERENCE_ERROR:
      return {
        ...state,
        domiciliationReferenceResponseError,
        isLoadingServiceDomiciliation: false,
        domiciliationReferenceResponse: {},
      };
    case SET_DOMICILIATION_REFERENCE_VALUES:
      return {
        ...state,
        reference,
        expirationDate,
        amountValue,
        tcValue,
      };
    case CAN_CALL_NIP:
      return {
        ...state,
        canCallNip,
      };
      case CAN_UPSELL_N2:
        return {
          ...state,
          canUpsellN2,
        };
    case SET_GO_TO_DOMICILIATION_FORM:
      return {
        ...state,
        goToDomiciliationForm: payload,
      };
    case SET_DATE_FROM_NATIVE_DATE_PICKER:
      return {
        ...state,
        dateValueFromNativeDatePicker: payload,
      };
    case SET_FROM_ACTION_VALUE:
      return {
        ...state,
        fromActionValue: payload,
      };
    case SET_TERMS_CHECKBOX:
      return {
        ...state,
        tcInputIsValid: payload,
      };
    case SET_MAX_AMOUNT_VALUE:
      return {
        ...state,
        maxAmountValueFromStore: payload,
      };
    default:
      return state;
  }
};
